import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './FormField.css';
import React, { useState, useRef } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
var FormField = function FormField(_ref) {
  var name = _ref.name,
    placeholder = _ref.placeholder,
    value = _ref.value,
    changeEvent = _ref.changeEvent,
    blurEvent = _ref.blurEvent,
    type = _ref.type,
    label = _ref.label,
    id = _ref.id,
    labelLight = _ref.labelLight,
    fieldError = _ref.fieldError,
    _ref$autoComplete = _ref.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$requiredFromCont = _ref.requiredFromContent,
    requiredFromContent = _ref$requiredFromCont === void 0 ? false : _ref$requiredFromCont,
    focusEvent = _ref.focusEvent,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    highLightText = _useState2[0],
    setHighLightText = _useState2[1];
  var clickedTextRef = useRef(false);
  function handleChange(event) {
    changeEvent(event.target.value);
  }
  function handleBlur(event) {
    if (blurEvent) blurEvent(event.target.value);
    clickedTextRef.current = false;
    setHighLightText(false);
  }
  function handleTextMousedown() {
    clickedTextRef.current = true;
  }
  function handleFocus(event) {
    if (focusEvent) focusEvent(event.target.value);
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label ".concat(labelLight ? 'lr__label-light' : ''),
    htmlFor: id
  }, label, required && !requiredFromContent ? /*#__PURE__*/React.createElement("strong", {
    className: "lr__red"
  }, "*") : ''), /*#__PURE__*/React.createElement("input", {
    className: "\n            form-input lr__field input-text-primary\n            ".concat(highLightText ? 'input-text-primary--focused' : '', "\n          "),
    name: name,
    placeholder: placeholder,
    type: type,
    value: value,
    id: id,
    onChange: handleChange,
    autoComplete: autoComplete,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onMouseDown: handleTextMousedown,
    title: label,
    "aria-label": label,
    disabled: isDisabled
  }), fieldError && fieldError.length ? /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, fieldError) : null));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStyles)
  }, children);
};
var commonStyles = "c1tcnk83";
var ltrStyles = "lwtdqpp";
var rtlStyles = "r1sdjuz8";
export default FormField;